import {
    useMemo,
} from 'react'
import {
    useUserRoles,
} from 'app/Auth'

import {
    ActiveTab as ActiveTabType,
} from 'app/MainMenu/MainMenu.types'

import useSelectedTab from '../../hooks/useSelectedTab'
import ActiveTab from './ActiveTab'

export default function ActiveTabContainer() {
    const {
        links, id,
    } = useSelectedTab() as ActiveTabType

    const roles = useUserRoles()

    const allowedLinks = useMemo(() => {
        return links.filter(({
            auth,
        }) => {
            return auth.some((role) => {
                return roles.includes(role)
            })
        })
    }, [
        links,
        roles,
    ])

    return (
        <ActiveTab
            module={id}
            links={allowedLinks}
        />
    )
}
